<section class="content" [ngClass]="{'bg-stripes': step > 1}">
    <div class="d-flex justify-content-end justify-content-md-end ">
      <button mat-icon-button class="btn-danger-custom" [mat-dialog-close]="file">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
    <div class="title" *ngIf="step !== 3">
        <p>{{data?.typeFile}}</p>
    </div>
    <div *ngIf="isCameraExist; else noCameraExist">
        <div class="content-photo">
            <ng-container *ngIf="step === 1">
                <div class="border-top-left"></div>
                <div class="border-top-right"></div>
                <div class="border-bottom-left"></div>
                <div class="border-bottom-right"></div>
                <div class="text-middle">Enfoca tu documento en la guía</div>
                <webcam [allowCameraSwitch]="false" [height]="410" [width]="310" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                    *ngIf="showWebcam" [switchCamera]="nextWebcamObservable"></webcam>
            </ng-container>
            <ng-container *ngIf="step === 2">
                <div class="border-complete"></div>
                <img class="webcam-image" [src]="webcamImage" alt="webcam-image"/>
            </ng-container>
            <ng-container *ngIf="step === 3">
                <div class="success">
                    <p class="title">Archivo recibido</p>
                    <mat-icon class="circle">check_circle_outline</mat-icon>
                </div>
            </ng-container>
        </div>
    
        <div *ngIf="errors.length > 0">
            <h4>Error Messages:</h4>
            <ul *ngFor="let error of errors">
                <li>{{ error }}</li>
            </ul>
        </div>
    </div>
    
    <ng-template #noCameraExist>
        Camera device not available
    </ng-template>

    <ng-container *ngIf="step === 1">
        <div class="recommendations">
            <ul>
                <li>Asegúrate que tu documento sea legible y vigente</li>
                <li>Usa un fondo oscuro</li>
            </ul>
        </div>
        <button mat-fab class="btn-camera" mat-fab (click)="takeSnapshot()">
            <img src="./assets/img/icon_camera.svg" alt="icon_camera" />
        </button>
    </ng-container>

    <ng-container *ngIf="step === 2">
        <button mat-button class="btn-use-photo" (click)="usePhoto()">
            Usar
        </button>
        <button mat-button class="btn-take-other" (click)="step = 1">
            Tomar otra foto
        </button>
    </ng-container>

    <ng-container *ngIf="step === 3">
        <button mat-button class="btn-return"  [mat-dialog-close]="file">
            Regresar
        </button>
    </ng-container>
</section>

